module.exports = {"app_name":"restaurants-socialbar","notifications":{"slack_channels":["restaurants-urgent"]},"deploy_annotations":["restaurants-socialbar-ssr"],"interactions":{},"app_ipm_scale":3,"lighthouse_links":["https://jonnybordo.wixsite.com/speedy"]}


//////////////////
// WEBPACK FOOTER
// ../fedops.json
// module id = 261
// module chunks = 0 1